var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlinds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 227V160H16L0 256H67C71.75 242.375 82.375 231.75 96 227ZM157 288C150.375 307.125 132.25 320 112 320S73.625 307.125 67 288H16L0 384H512L496 288H157ZM16 416L0 512H512L496 416H16ZM512 48V16C512 7.125 504.875 0 496 0H16C7.125 0 0 7.125 0 16V48C0 54.75 4.375 60.875 10.875 63L0 128H96V64H128V128H512L501.125 63C507.625 60.875 512 54.75 512 48ZM128 160V227C141.625 231.75 152.25 242.375 157 256H512L496 160H128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlinds);
export default __webpack_public_path__ + "static/media/blinds.1c8b55cb0b76233f1ad5a482b1811634.svg";
export { ForwardRef as ReactComponent };